if($('.type-category').length){
        function MhCategory(){
            if(!$('.category-header .filters-unveil-button-wrapper').length){
                $('.filters-unveil-button-wrapper').clone().appendTo('.category-header')
            }
            if(!$('#filters-wrapper #filters .close').length){
                $('#filters-wrapper #filters').prepend('<span class="close"></span>')
            }
            $('.filter-sections').prepend($('.slider-wrapper').addClass('filter-section'));
        }
        $(document).ready(function(){
            MhCategory()
        })
        document.addEventListener('ShoptetDOMContentLoaded', function () {
            MhCategory()
        });
}

$(document).on('click', 'span.close', function(){
    $('.filters-unveil-button-wrapper a').trigger('click')
    $('#filters').removeClass('visible')
    $('body').removeClass('filters-visible')

})

